import TYPOGRAPHY from '@/constants/typography';
import classNames from 'classnames';
import { CSSProperties, memo, PropsWithChildren } from 'react';

type ParagraphProps = {
  className?: string;
  size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl';
  style?: CSSProperties;
  dataTestId?: string;
};

const Paragraph = ({
  children,
  className,
  size = 'base',
  dataTestId,
  ...restProps
}: PropsWithChildren<ParagraphProps>) =>
  children ? (
    <p
      data-testid={dataTestId}
      className={classNames('font-primary', TYPOGRAPHY.paragraph[size] ?? '', className)}
      {...restProps}
    >
      {children}
    </p>
  ) : null;

export default memo(Paragraph);
